import { useState, useCallback, ChangeEvent, Dispatch, SetStateAction } from "react";
import { Responses } from "@/components/Quiz/useQuiz";

interface Props {
  initialVal?: string;
  setCurrentStepHasValue: (val: boolean) => void;
  setResponses: Dispatch<SetStateAction<Responses | undefined>>;
  questionId: number;
}

function useSingleSelect({ initialVal, setCurrentStepHasValue, setResponses, questionId }: Props) {
  const [val, setVal] = useState(initialVal ?? "");
  const [skipChecked, setSkipChecked] = useState(initialVal === "skip");

  const onChange = useCallback(
    (ev: ChangeEvent<HTMLInputElement>) => {
      const newVal = ev.target.value;
      setVal(newVal);
      if (newVal) {
        setCurrentStepHasValue(true);
      } else {
        setCurrentStepHasValue(false);
      }
      setResponses((prev: any) => {
        prev[questionId] = [newVal];
        return prev;
      });
    },
    [questionId, setCurrentStepHasValue, setResponses]
  );

  const handleSkipToggle = useCallback(
    (ev: React.ChangeEvent<HTMLInputElement>) => {
      if (ev.target.checked) {
        setSkipChecked(true);
        setVal("");
        setCurrentStepHasValue(true);
        setResponses((prev: any) => {
          prev[questionId] = ["skip"];
          return prev;
        });
      } else {
        setSkipChecked(false);
        setCurrentStepHasValue(false);
        setResponses((prev: any) => {
          prev[questionId] = undefined;
          return prev;
        });
      }
    },
    [questionId, setCurrentStepHasValue, setResponses]
  );

  return {
    val,
    onChange,
    skipChecked,
    handleSkipToggle,
  };
}

export default useSingleSelect;
